import { render, staticRenderFns } from "./ContributorConfigurator.vue?vue&type=template&id=6ae97a3f&"
import script from "./ContributorConfigurator.vue?vue&type=script&lang=js&"
export * from "./ContributorConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports